import { render, staticRenderFns } from "./CustomersNew.vue?vue&type=template&id=16d442ad&"
import script from "./CustomersNew.vue?vue&type=script&lang=ts&"
export * from "./CustomersNew.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersNew.vue?vue&type=style&index=0&id=16d442ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports